module.exports = __webpack_public_path__ + "static/media/delete-organization.a8038fc3.svg";